import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

export enum CustomerTab {
    requests = "requests",
    offers = "offers",
    outgoingInvoices = "outgoing-invoices",
    documents = "documents",
}

interface ICustomerRouteParams {
    customerNumber: Guid
    tab: CustomerTab
}

const CustomerRoute = new AppRoute<ICustomerRouteParams>({
    route: "/customers/:customerNumber/:tab",
    navbar: true,
    authRequired: true,
    minWidth: "auto",
})

export default CustomerRoute
